import { Dispatch, ReactNode, SetStateAction } from 'react';

import { Position } from 'coreOld/enums';

import { TooltipWrapper, TooltipTarget, CenterContainer, TooltipBox } from './tooltipStyle';

interface IProps {
  position: Position;
  text: string | JSX.Element;
  children?: ReactNode;
  showTooltip: boolean;
  tooltipOpacity?: number;
  backgroundColor?: string;
  setIsHovered: Dispatch<SetStateAction<boolean>>;
}

const TooltipView = ({
  position,
  text,
  children,
  setIsHovered,
  showTooltip,
  tooltipOpacity = 0.92,
  backgroundColor,
}: IProps) => {
  return (
    <TooltipWrapper>
      <TooltipTarget
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {children}
      </TooltipTarget>

      <CenterContainer position={position}>
        <TooltipBox
          position={position}
          showTooltip={showTooltip}
          tooltipOpacity={tooltipOpacity}
          backgroundColor={backgroundColor}
        >
          {text}
        </TooltipBox>
      </CenterContainer>
    </TooltipWrapper>
  );
};

export default TooltipView;
